import { FolkSand } from '../folk-sand';
FolkSand.define();
export { FolkSand };
//# sourceMappingURL=folk-sand.js.map